import { connect } from 'react-redux'
import { currentUserNameSelector } from 'common/auth/selectors'
import { logout } from 'common/auth/actions'
import { getTokenAccessLevel } from 'common/auth/token'
import Header from './Header'

const mapStateToProps = state => ({
  username: currentUserNameSelector(state),
  accessLevel: getTokenAccessLevel()
})

const mapDispatchToProps = { logout }

export default connect(mapStateToProps, mapDispatchToProps)(Header)
